let cd = new URLSearchParams(window.location.search.replace('?', '')).get('cd')
let campaign = localStorage.getItem('campaign')
if (cd && campaign === null) {
  campaign = {'dealerSlug': cd}
  localStorage.setItem('campaign', JSON.stringify(campaign))

  window.addEventListener("load", () => {
    $.getJSON(
      'https://hub.wimmer-wohnkollektionen.de/shop-api/dealers/slug/',
      {'slug': cd},
      function (response) {
        if (response) {
          let dealerName = response['name']

          if (dealerName) {
            campaign['dealerName'] = dealerName
            localStorage.setItem('campaign', JSON.stringify(campaign))
          }
        }
      })
  })

}
